import React, { useState, useEffect } from "react";
import { Layout, Typography, Card, Row, Col, Button, Input } from "antd";
import axios from "axios";
import TextArea from "antd/es/input/TextArea";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import { API_URL } from "../../config";
import moment from "moment";

const { Title } = Typography;
const { Content } = Layout;

const MedicalTab = (props) => {
  const { patient_id, appointmentId, patientDetails } = props;
  const [medicalHistory, setMedicalHistory] = useState("");
  const [consultationNotes, setConsultationNotes] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [originalMedicalHistory, setOriginalMedicalHistory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios
      .get(`${API_URL}/user/${patient_id}`)
      .then((response) => {
        setMedicalHistory(response.data.medical_history);
        setOriginalMedicalHistory(response.data.medical_history);
      })
      .catch((error) => {
        console.error("Error fetching medical history:", error);
      });

    axios
      .get(`${API_URL}/user/patients/${patient_id}/notes/`)
      .then((response) => {
        const filteredNotes = response.data.notes.filter(
          (note) =>
            note.title &&
            note.contents &&
            note.appointment_id !== appointmentId,
        );
        setConsultationNotes(filteredNotes);
      })
      .catch((error) => {
        console.error("Error fetching past consultation notes:", error);
      });
  }, [patient_id, appointmentId]);

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const saveMedicalHistory = () => {
    axios
      .patch(`${API_URL}/user/${patient_id}`, {
        medical_history: medicalHistory,
      })
      .then((response) => {
        console.log("Medical history updated successfully:", response.data);
        setOriginalMedicalHistory(medicalHistory);
        setIsEditing(false);
      })
      .catch((error) => {
        console.error("Error updating medical history:", error);
      });
  };

  const cancelEdit = () => {
    setMedicalHistory(originalMedicalHistory);
    setIsEditing(false);
  };

  const formatContents = (contents) => {
    const lines = contents.split("\n");
    let formattedLines = [];
    const numberedItemRegex = /^(\d+\))\s?(.*)/;

    lines.forEach((line, index) => {
      const match = line.match(numberedItemRegex);
      if (match) {
        formattedLines.push(
          <span key={index}>
            <strong>{match[1]}</strong> {match[2]}
          </span>,
        );
      } else {
        formattedLines.push(<span key={index}>{line}</span>);
      }
      formattedLines.push(<br key={`br-${index}`} />);
    });

    return formattedLines;
  };

  const filteredNotes = consultationNotes.filter((note) =>
    note.contents.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <React.Fragment>
      <Content>
        <Row align="middle" justify="space-between">
          <Col>
            <Title level={3}>Medical History</Title>
          </Col>
          <Col>
            <Button
              icon={isEditing ? <SaveOutlined /> : <EditOutlined />}
              type="link"
              onClick={isEditing ? saveMedicalHistory : toggleEdit}
            />
          </Col>
        </Row>
        <TextArea
          value={medicalHistory}
          rows={6}
          disabled={!isEditing}
          onChange={(e) => setMedicalHistory(e.target.value)}
          style={{
            color: "black",
            backgroundColor: isEditing ? "white" : "#f5f5f5",
          }}
        />
        {isEditing && (
          <Row justify="end" style={{ marginTop: 10 }}>
            <Button type="primary" onClick={saveMedicalHistory}>
              Save
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={cancelEdit}>
              Cancel
            </Button>
          </Row>
        )}

        {patientDetails?.purpose && (
          <>
            <Title level={4}>Patient Notes</Title>
            <Card style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: 0 }}>{patientDetails?.purpose}</p>
              </div>
            </Card>
          </>
        )}

        <Title level={4}>Past Consultation Notes</Title>
        <Input
          placeholder="Search notes"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <div
          style={{
            maxHeight: "350px",
            overflowY: "auto",
            paddingRight: "8px",
          }}
        >
          {filteredNotes.map((note, index) => (
            <Card key={index} style={{ marginBottom: "16px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <p style={{ margin: 0, wordWrap: "break-word" }}>
                  {formatContents(note.contents)}
                </p>
              </div>
              <Row justify="end" align="middle">
                <Col>
                  {note.doctor?.first_name && note.doctor?.last_name ? (
                    <p>{`${note.doctor.first_name} ${note.doctor.last_name}`}</p>
                  ) : (
                    ""
                  )}
                  {moment(note.last_modified).format("DD/MM/YYYY LT")}
                </Col>
              </Row>
            </Card>
          ))}
        </div>
      </Content>
    </React.Fragment>
  );
};

export default MedicalTab;
